import {
  ActiveTaskResponse,
  CisgenicTaskProgress,
  UploadCommonDataResponse,
} from '@/types/cisgenicTask'
import axiosClient from '../axiosClient'

export type UploadCommonDataResult =
  | { type: 'success'; data: UploadCommonDataResponse }
  | { type: 'validation-error'; blob: Blob }

export const cisgenicTaskApi = {
  async uploadCommonDataV2(
    interfaceId: number,
    data: FormData
  ): Promise<UploadCommonDataResult> {
    const url = `/api/v2/Setup/${interfaceId}/import/upload-common-data`
    const response = await axiosClient.post(url, data, {
      headers: { 'Content-Type': 'multipart/form-data' },
      responseType: 'arraybuffer',
    })

    const contentType = response.headers['content-type'] || ''

    // Check if response is a file (ZIP/XLSX) - validation error file
    if (
      contentType.includes('application/vnd.openxmlformats') ||
      contentType.includes('application/zip') ||
      contentType.includes('application/octet-stream')
    ) {
      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })

      return { type: 'validation-error', blob }
    }

    // Response is JSON - parse it
    const jsonString = new TextDecoder().decode(response.data)
    const jsonData: UploadCommonDataResponse = JSON.parse(jsonString)
    return { type: 'success', data: jsonData }
  },

  getActiveUploadTask(interfaceId: number) {
    const url = `/api/v2/Setup/${interfaceId}/import/upload-common-data/active`
    return axiosClient.get<ActiveTaskResponse>(url)
  },

  getTaskProgress(taskId: string) {
    const url = `/api/cisgenic-task/${taskId}/progress`
    return axiosClient.get<CisgenicTaskProgress>(url)
  },

  // MK2 Decoder V2 endpoints
  uploadMk2DecoderV2(interfaceId: number, data: FormData) {
    const url = `/api/v2/Setup/${interfaceId}/import/upload-mk2-decoder`
    return axiosClient.post<UploadCommonDataResponse>(url, data, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  },

  getActiveMk2DecoderTask(interfaceId: number) {
    const url = `/api/v2/Setup/${interfaceId}/import/upload-mk2-decoder/active`
    return axiosClient.get<ActiveTaskResponse>(url)
  },

  cancelTask(taskId: string) {
    const url = `/api/cisgenic-task/${taskId}/cancel`
    return axiosClient.post<{ success: boolean; message: string }>(url)
  },
}

export default cisgenicTaskApi
